// BarChartComponent.tsx
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { barChartData } from '../../../data/ChartData';

const BarChartComponent = () => {
  return (
    <ResponsiveContainer width='100%' height={300}>
      <BarChart data={barChartData}>
        <CartesianGrid strokeDasharray='3 3' />
        <XAxis dataKey='year' />
        <YAxis />
        <Tooltip />
        <Bar dataKey='projects' fill='#52bf92' barSize={30} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarChartComponent;
